<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col h-full">
      <div class=" md:text-left w-full my-auto text-center">
        <div
          class=" md:grid-flow-col md:gap-10 grid w-full max-h-full grid-cols-1 gap-6 text-xl"
          :class="{ 'md:grid-cols-3': !col }"
        >
          <div class="md:col-span-2 col-span-full border-b">
            <div class="md:w-10/12 ">
              <img class=" object-contain w-full" :src="page.bannerImage" />
            </div>
          </div>

          <div
            class="auto-rows-min md:grid-cols-2 md:col-span-2 md:row-start-2 grid gap-4"
          >
            <app-link
              v-for="link in page.linkList"
              :key="link.path"
              v-bind="link"
            />
          </div>
          <div class="md:row-start-1 flex items-end pb-2 text-2xl border-b">
            Seguici
          </div>
          <div class="md:row-start-2 grid gap-4">
            <app-link
              v-for="link in page.socialList"
              :key="link.path"
              v-bind="link"
            />
          </div>
          <div
            class="md:row-start-3 md:col-span-full md:flex-nowrap md:justify-start flex flex-wrap items-center justify-center py-2 text-base border-t"
            v-if="page.legalReference"
          >
            <span v-html="page.legalReference.text" />
            <img class="h-8 ml-2" :src="page.legalReference.logo" />
          </div>
        </div>
      </div>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
        button-style="brand"
      />
    </div>
    <transition name="pop">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import AppLink from "@/components/nav/AppLink";
import { matchedRouteKey } from "vue-router";

export default {
  inject: [matchedRouteKey],
  components: { AppLink },
  props: { navigate: { default: null } },
  computed: {
    navRoute() {
      return this[matchedRouteKey].value;
    }
  },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  },
  async beforeRouteUpdate() {
    let page;
    try {
      page = await axios.get(`/pageContent${this.navRoute.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      this.page = page.data;
    }
  }
};
</script>
<route>
{
  "name": "footer",
  "meta": {
      "order": 13,
      "label": "Trasparenza e Contatti",
      "hideMenu": {
        "inline": true
      }
  }
}
</route>
